import React, { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import Logos from './Logos'
import Review from './Review'
import Our from './Our'
import Footer from './Footer'


export default function Car() {

  const [productMake, setproductMake] = useState([])
  const [productModel, setproductModel] = useState([])
  const newMake = useRef('');
  const newURL = useRef('');
  const BASE_URL = 'https://node.insuranceadvisors.pk';

  const handleChange = (event) => {
    newMake.current = event.currentTarget.value 
    newURL.current = BASE_URL + '/api/findprd/' + newMake.current
    getAllProductModel()
    event.preventDefault()
  };

  const getAllProductModel = async () =>{  
    try{
      await axios.get(newURL.current).then((res) =>{
        setproductModel(res.data)
      }).catch((err) =>{
        console.log(err)
      })
    }catch(error){
      console.log(error)
    }
  }
  
  function getAllProductMake(){
    // var url = 'https://fakestoreapi.com/products'
    var url = BASE_URL + '/api/findprd'
    axios.get(url).then((res) =>{
      // alert(res.data[1])
      setproductMake(res.data)
    }).catch((err) =>{
      console.log(err)
    })
  }
  
  useEffect(()=>{
    getAllProductMake()
  })



  const [cart, setCart] = useState([]);
  const saveCartItems = (cart) => {
    const saveapi = BASE_URL + "/api/saveorder"
    
    cart.map((product)=>
    axios.post(saveapi, {
      id: product.id,
      name: product.name,
      contact: product.contact,
      email: product.email,
      productModel: product.productModel,
      productMake: product.productMake,
      manufacturingYear: product.manufacturingYear,
      estimatedValue: product.estimatedValue
    }).then((res)=>{
      console.log(res)
      alert("Order Confirmed")
      }).catch((err)=>{
      console.log(err)
      alert(err)
      })
    )
  
    
  }

return (
    <div>


{/*  */}
<div className='container-fluid trvl'>
  <h5><marquee>LIMITED TIME OFFER...Offering upto 10% discount on Car Insurance.</marquee></h5>
 </div>
  <br/>
{/*  */}



<div class="container col-sm-12">
  <div class="row">
   
    <div class="col-sm-6">
      <img src="./assets/img/car.png"  width="90%" height="500px" ></img>
    </div>
   
   

<div class="col-sm-6"   id="d1">
    
  <h3 className='cl32'> Enter Your Details </h3> 


<form method='POST' action="${BASE_URL}/api/saveorder">


<select class="form-control form-control-md"  list="datalistOptions" name='productMake' placeholder="Car Brand" required
aria-label=".form-control-md example" onChange={handleChange}>
  <option value='' selected > Choose Your Car Make </option>
  {productMake.map((content) =>(
    <option value={content}> {content} </option>
  ))}
</select>


<br/>
<select class="form-control form-control-md" name='productModel' value={newMake.current} id="exampleFormControlSelect1" required>
  {productModel.map((content) =>(
    <option value={content.productModel}> {content.productModel} </option>
  ))}
</select>
<br/>
<div class="container">
  <div class="row">
  <div class="col-1">
      
    </div>
  <input class="form-control form-control-md" id="mj"  placeholder="Manufacturing Year" required name='manufacturingYear' aria-label=".form-control-lg example"/>
<br/>
&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
<input class="form-control form-control-md" id="mj"  placeholder="Current Value" required name='estimatedValue' aria-label=".form-control-lg example" />
<br/>
  </div>
</div>

<div id="d3" ></div>

<div class="container">
  <div class="row">
  <div class="col-1">
      
      </div>
  <input class="form-control form-control-md" type='name' name='name' id="mj" placeholder="Enter Your Name"  aria-label=".form-control-lg example" />
<br/>
&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
<input class="form-control form-control-md" type='number' name='contact'id="mj" placeholder="Enter Your Contact no" aria-label=".form-control-lg example"/>

    
    
  </div>
</div>

<br/>

<input class="form-control form-control-md" type='email' name='email'  placeholder="Enter Your Email" aria-label=".form-control-lg example"/>
<br/>



<br/>
<div id="d3" >

{/* <a href='/car' class="btn btn-danger btn-md" id="d2"> BACK</a> */}
&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;

<button type="submit" class="btn btn-danger btn-lg" id="d2" onClick={() => saveCartItems(cart)}> Submit </button>
</div>            

</form>
    </div>
  </div>
</div>



{/* **************  CODE OF LOGOS STARTS HERE ************ */}
<div>
  <Logos></Logos>
</div> <br/><br/><br/><br/>
{/*  **************  CODE OF LOGOS ENDS HERE ************ */}


<div>
  <Review></Review>
</div>    <br/><br/><br/><br/><br/>



{/*  *******************  CODE OF CARDS STARTS HERE*********************  */   }
<div className='b1'>

<div class="container" id="mid">
  <div class="row">
   
    <div class="col-lg-12"> <br/>
    <h1 id="a5"><strong> TYPES OF CAR INSURANCE </strong></h1>
    <p> We provide an array of services with the guidance of over 25 digital experts who are specialists in their 
      respective fields.
 </p>
    </div>
  </div>
</div>

<div class="container">
  <div class="row">
    <div className='col-1'></div>
      <div class="col-md-3" id="a6">
      <br/>
    <div id="mid">
    <h5 id="a8"> Comprehensive Coverage </h5></div>
  <p id="a7">
    "Get total peace of mind with our Comprehensive Car Coverage. Protecting you from accidents, theft, and 
    nature's surprises, our policy ensures your vehicle is secure inside and out. Drive confidently knowing 
    you're covered for collisions, vandalism, and more.Experience worry-free journeys with our trusted
    insurance."
   </p>
</div>
                    
<div class="col-md-3" id="a6">
<br/>
  <div id="mid">
    <h5 id="a8"> Third Party Insurance </h5></div>
    <p id="a7">
    "Stay legally protected on the road with our Third Party Car Insurance. Offering essential coverage for damage to 
    others' property and injury to third parties, our policy ensures compliance with regulations while keeping you 
    financially secure. Drive with confidence, knowing you have reliable insurance at your side for peace of mind."
   </p>
</div>
          
  <div class="col-md-3" id="a6">
    <br/>
  <div id="mid">
    <h5 id="a8"> 3T Insurance </h5></div>
      <p id="a7"> 
      "Upgrade your coverage to the next level with our 3T Insurance. Combining Third Party, Theft, and Total Loss 
      protection, this comprehensive policy shields you from all angles. Drive worry-free, knowing you're covered for 
      damages to others, theft of your vehicle, and total loss situations. Drive smart, drive protected with 3T Insurance."
      </p>
  </div>
  </div>
  </div>
  <br/>
  </div>

{/* *******************  CODE OF CARDS STARTS HERE********************* */}


{/* ********  Section of 3 steps STARTS HERE ******* */}

<div>

<div className="bg-light">
  <br/> <br/>
    <h1 className="achieve1"> GET INSURED IN THREE EASY STEPS </h1>
  <br/><br/>  
    <div class="container">
  <div class="row">
    
    <div class="col-sm-4 cl1">
     <img src='https://www.easyinsurance.com.pk/images/supporter/Step2.svg' width='100px' />
  <br/><br/>
     <h3 className='cl1'><strong> Compare Plans </strong> </h3> 
     <p className='cl1'> View and Compare Quotes of different Insurance Companies </p>
    </div>

    <div class="col-sm-4 cl1">
    <img src='https://www.easyinsurance.com.pk/images/supporter/Step3.svg' width='100px' />
    <br/><br/>  
     <h3 className='cl1'> <strong> Buy Online </strong></h3><br/>
     <p className='cl1'> Get insured from the company of your choice instantly through us </p>
    </div>

    <div class="col-sm-4 cl1">
    <img src='https://www.easyinsurance.com.pk/images/supporter/Step1.svg' width='100px'></img>
    <br/><br/>
    <h3 className='cl1'> <strong>  Enter Details </strong> </h3>
    <p className='cl1'>  Answer some basic questions so we can calculate quotes personalized for you </p>
    </div>
  </div>
</div>

    </div>
<br/><br/>

</div>

{/* ********  Section of 3 Easy steps ENDS HERE *****  */}


<div>
  <Footer></Footer>
</div>

    </div>
  )
}
